import { h as M, i as b, u as ve, j as l, B as R, p as be, l as Z, x as _e, U as we, o as tt, H as ot, m as xe, q as te, w as nt, s as st, n as at, r as fe, t as Le } from "./UnstyledButton-ujNMaBde.js";
import rt, { useMemo as it, useRef as z, useState as Ee, useEffect as lt, forwardRef as Ae, cloneElement as ct } from "react";
import { g as dt } from "./get-style-object-D6lVXaRM.js";
import { flushSync as ut } from "react-dom";
import { c as pt, m as mt, b as ht, a as se } from "./CloseButton-Bp_UJ8Gq.js";
import { a as $e, P as K, c as gt, i as ft, u as yt, g as vt, j as bt, b as wt, G as xt } from "./Button-CMUmoC07.js";
import { c as Ce, u as Fe } from "./DirectionProvider-DtCDJ2BX.js";
import { A as Ct } from "./AccordionChevron-D-UrV_dq.js";
import { a as Pt, b as St, S as Mt } from "./Checkbox-Uem0EnXG.js";
function ne(e, o) {
  let t = e;
  for (; (t = t.parentElement) && !t.matches(o); )
    ;
  return t;
}
function Dt(e, o, t) {
  for (let n = e - 1; n >= 0; n -= 1)
    if (!o[n].disabled)
      return n;
  if (t) {
    for (let n = o.length - 1; n > -1; n -= 1)
      if (!o[n].disabled)
        return n;
  }
  return e;
}
function It(e, o, t) {
  for (let n = e + 1; n < o.length; n += 1)
    if (!o[n].disabled)
      return n;
  if (t) {
    for (let n = 0; n < o.length; n += 1)
      if (!o[n].disabled)
        return n;
  }
  return e;
}
function Tt(e, o, t) {
  return ne(e, t) === ne(o, t);
}
function Oe({
  parentSelector: e,
  siblingSelector: o,
  onKeyDown: t,
  loop: n = !0,
  activateOnFocus: c = !1,
  dir: r = "rtl",
  orientation: s
}) {
  return (a) => {
    t?.(a);
    const i = Array.from(
      ne(a.currentTarget, e)?.querySelectorAll(
        o
      ) || []
    ).filter((d) => Tt(a.currentTarget, d, e)), m = i.findIndex((d) => a.currentTarget === d), u = It(m, i, n), h = Dt(m, i, n), g = r === "rtl" ? h : u, f = r === "rtl" ? u : h;
    switch (a.key) {
      case "ArrowRight": {
        s === "horizontal" && (a.stopPropagation(), a.preventDefault(), i[g].focus(), c && i[g].click());
        break;
      }
      case "ArrowLeft": {
        s === "horizontal" && (a.stopPropagation(), a.preventDefault(), i[f].focus(), c && i[f].click());
        break;
      }
      case "ArrowUp": {
        s === "vertical" && (a.stopPropagation(), a.preventDefault(), i[h].focus(), c && i[h].click());
        break;
      }
      case "ArrowDown": {
        s === "vertical" && (a.stopPropagation(), a.preventDefault(), i[u].focus(), c && i[u].click());
        break;
      }
      case "Home": {
        a.stopPropagation(), a.preventDefault(), !i[0].disabled && i[0].focus();
        break;
      }
      case "End": {
        a.stopPropagation(), a.preventDefault();
        const d = i.length - 1;
        !i[d].disabled && i[d].focus();
        break;
      }
    }
  };
}
function w(e, o) {
  return (t) => {
    e?.(t), o?.(t);
  };
}
function jt(e, o, t) {
  return t ? Array.from(
    ne(t, o)?.querySelectorAll(e) || []
  ).findIndex((n) => n === t) : null;
}
function $(e, o) {
  const t = o - e + 1;
  return Array.from({ length: t }, (n, c) => c + e);
}
const ee = "dots";
function Nt({
  total: e,
  siblings: o = 1,
  boundaries: t = 1,
  page: n,
  initialPage: c = 1,
  onChange: r
}) {
  const s = Math.max(Math.trunc(e), 0), [a, i] = $e({
    value: n,
    onChange: r,
    defaultValue: c,
    finalValue: c
  }), m = (p) => {
    p <= 0 ? i(1) : p > s ? i(s) : i(p);
  }, u = () => m(a + 1), h = () => m(a - 1), g = () => m(1), f = () => m(s);
  return {
    range: it(() => {
      if (o * 2 + 3 + t * 2 >= s)
        return $(1, s);
      const y = Math.max(a - o, t), v = Math.min(a + o, s - t), x = y > t + 2, N = v < s - (t + 1);
      if (!x && N) {
        const C = o * 2 + t + 2;
        return [...$(1, C), ee, ...$(s - (t - 1), s)];
      }
      if (x && !N) {
        const C = t + 1 + 2 * o;
        return [...$(1, t), ee, ...$(s - C, s)];
      }
      return [
        ...$(1, t),
        ee,
        ...$(y, v),
        ee,
        ...$(s - t + 1, s)
      ];
    }, [s, o, a]),
    active: a,
    setPage: m,
    next: u,
    previous: h,
    first: g,
    last: f
  };
}
function kt(e) {
  if (!e || typeof e == "string")
    return 0;
  const o = e / 36;
  return Math.round((4 + 15 * o ** 0.25 + o / 5) * 10);
}
function ge(e) {
  return e?.current ? e.current.scrollHeight : "auto";
}
const W = typeof window < "u" && window.requestAnimationFrame, Re = 0, Lt = (e) => ({
  height: 0,
  overflow: "hidden",
  ...e ? {} : { display: "none" }
});
function Rt({
  transitionDuration: e,
  transitionTimingFunction: o = "ease",
  onTransitionEnd: t = () => {
  },
  opened: n,
  keepMounted: c = !1
}) {
  const r = z(null), s = Lt(c), [a, i] = Ee(n ? {} : s), m = (d) => {
    ut(() => i(d));
  }, u = (d) => {
    m((p) => ({ ...p, ...d }));
  };
  function h(d) {
    const p = e || kt(d);
    return {
      transition: `height ${p}ms ${o}, opacity ${p}ms ${o}`
    };
  }
  pt(() => {
    typeof W == "function" && W(n ? () => {
      u({ willChange: "height", display: "block", overflow: "hidden" }), W(() => {
        const d = ge(r);
        u({ ...h(d), height: d });
      });
    } : () => {
      const d = ge(r);
      u({ ...h(d), willChange: "height", height: d }), W(() => u({ height: Re, overflow: "hidden" }));
    });
  }, [n]);
  const g = (d) => {
    if (!(d.target !== r.current || d.propertyName !== "height"))
      if (n) {
        const p = ge(r);
        p === a.height ? m({}) : u({ height: p }), t();
      } else a.height === Re && (m(s), t());
  };
  function f({ style: d = {}, refKey: p = "ref", ...y } = {}) {
    const v = y[p], x = {
      "aria-hidden": !n,
      ...y,
      [p]: mt(r, v),
      onTransitionEnd: g,
      style: { boxSizing: "border-box", ...d, ...a }
    };
    return rt.version.startsWith("18") ? n || (x.inert = "") : x.inert = !n, x;
  }
  return f;
}
const _t = {
  transitionDuration: 200,
  transitionTimingFunction: "ease",
  animateOpacity: !0
}, Et = M((e, o) => {
  const {
    children: t,
    in: n,
    transitionDuration: c,
    transitionTimingFunction: r,
    style: s,
    onTransitionEnd: a,
    animateOpacity: i,
    keepMounted: m,
    ...u
  } = b("Collapse", _t, e), h = ve(), g = ht(), d = (h.respectReducedMotion ? g : !1) ? 0 : c, p = Rt({
    opened: n,
    transitionDuration: d,
    transitionTimingFunction: r,
    onTransitionEnd: a,
    keepMounted: m
  });
  return d === 0 ? n ? /* @__PURE__ */ l.jsx(R, { ...u, children: t }) : null : /* @__PURE__ */ l.jsx(
    R,
    {
      ...p({
        style: {
          opacity: n || !i ? 1 : 0,
          transition: i ? `opacity ${d}ms ${r}` : "none",
          ...dt(s, h)
        },
        ref: o,
        ...u
      }),
      children: t
    }
  );
});
Et.displayName = "@mantine/core/Collapse";
function ze({ open: e, close: o, openDelay: t, closeDelay: n }) {
  const c = z(-1), r = z(-1), s = () => {
    window.clearTimeout(c.current), window.clearTimeout(r.current);
  }, a = () => {
    s(), t === 0 || t === void 0 ? e() : c.current = window.setTimeout(e, t);
  }, i = () => {
    s(), n === 0 || n === void 0 ? o() : r.current = window.setTimeout(o, n);
  };
  return lt(() => s, []), { openDropdown: a, closeDropdown: i };
}
var He = { root: "m_4451eb3a" };
const Be = be((e, o) => {
  const t = b("Center", null, e), {
    classNames: n,
    className: c,
    style: r,
    styles: s,
    unstyled: a,
    vars: i,
    inline: m,
    mod: u,
    attributes: h,
    ...g
  } = t, f = Z({
    name: "Center",
    props: t,
    classes: He,
    className: c,
    style: r,
    classNames: n,
    styles: s,
    unstyled: a,
    attributes: h,
    vars: i
  });
  return /* @__PURE__ */ l.jsx(R, { ref: o, mod: [{ inline: m }, u], ...f("root"), ...g });
});
Be.classes = He;
Be.displayName = "@mantine/core/Center";
const [At, F] = Ce(
  "Menu component was not found in the tree"
);
var O = { dropdown: "m_dc9b7c9f", label: "m_9bfac126", divider: "m_efdf90cb", item: "m_99ac2aa1", itemLabel: "m_5476e0d3", itemSection: "m_8b75e504", chevron: "m_b85b0bed" };
const Pe = M((e, o) => {
  const { classNames: t, className: n, style: c, styles: r, vars: s, ...a } = b(
    "MenuDivider",
    null,
    e
  ), i = F();
  return /* @__PURE__ */ l.jsx(
    R,
    {
      ref: o,
      ...i.getStyles("divider", { className: n, style: c, styles: r, classNames: t }),
      ...a
    }
  );
});
Pe.classes = O;
Pe.displayName = "@mantine/core/MenuDivider";
const Se = M((e, o) => {
  const {
    classNames: t,
    className: n,
    style: c,
    styles: r,
    vars: s,
    onMouseEnter: a,
    onMouseLeave: i,
    onKeyDown: m,
    children: u,
    ...h
  } = b("MenuDropdown", null, e), g = z(null), f = F(), d = w(m, (v) => {
    (v.key === "ArrowUp" || v.key === "ArrowDown") && (v.preventDefault(), g.current?.querySelectorAll("[data-menu-item]:not(:disabled)")[0]?.focus());
  }), p = w(
    a,
    () => (f.trigger === "hover" || f.trigger === "click-hover") && f.openDropdown()
  ), y = w(
    i,
    () => (f.trigger === "hover" || f.trigger === "click-hover") && f.closeDropdown()
  );
  return /* @__PURE__ */ l.jsxs(
    K.Dropdown,
    {
      ...h,
      onMouseEnter: p,
      onMouseLeave: y,
      role: "menu",
      "aria-orientation": "vertical",
      ref: se(o, g),
      ...f.getStyles("dropdown", {
        className: n,
        style: c,
        styles: r,
        classNames: t,
        withStaticClass: !1
      }),
      tabIndex: -1,
      "data-menu-dropdown": !0,
      onKeyDown: d,
      children: [
        f.withInitialFocusPlaceholder && /* @__PURE__ */ l.jsx("div", { tabIndex: -1, "data-autofocus": !0, "data-mantine-stop-propagation": !0, style: { outline: 0 } }),
        u
      ]
    }
  );
});
Se.classes = O;
Se.displayName = "@mantine/core/MenuDropdown";
const [$t, ae] = gt(), Me = be((e, o) => {
  const {
    classNames: t,
    className: n,
    style: c,
    styles: r,
    vars: s,
    color: a,
    closeMenuOnClick: i,
    leftSection: m,
    rightSection: u,
    children: h,
    disabled: g,
    "data-disabled": f,
    ...d
  } = b("MenuItem", null, e), p = F(), y = ae(), v = ve(), { dir: x } = Fe(), N = z(null), C = d, D = w(C.onClick, () => {
    f || (typeof i == "boolean" ? i && p.closeDropdownImmediately() : p.closeOnItemClick && p.closeDropdownImmediately());
  }), P = a ? v.variantColorResolver({ color: a, theme: v, variant: "light" }) : void 0, k = a ? _e({ color: a, theme: v }) : null, E = w(C.onKeyDown, (L) => {
    L.key === "ArrowLeft" && y && (y.close(), y.focusParentItem());
  });
  return /* @__PURE__ */ l.jsxs(
    we,
    {
      onMouseDown: (L) => L.preventDefault(),
      ...d,
      unstyled: p.unstyled,
      tabIndex: p.menuItemTabIndex,
      ...p.getStyles("item", { className: n, style: c, styles: r, classNames: t }),
      ref: se(N, o),
      role: "menuitem",
      disabled: g,
      "data-menu-item": !0,
      "data-disabled": g || f || void 0,
      "data-mantine-stop-propagation": !0,
      onClick: D,
      onKeyDown: Oe({
        siblingSelector: "[data-menu-item]:not([data-disabled])",
        parentSelector: "[data-menu-dropdown]",
        activateOnFocus: !1,
        loop: p.loop,
        dir: x,
        orientation: "vertical",
        onKeyDown: E
      }),
      __vars: {
        "--menu-item-color": k?.isThemeColor && k?.shade === void 0 ? `var(--mantine-color-${k.color}-6)` : P?.color,
        "--menu-item-hover": P?.hover
      },
      children: [
        m && /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemSection", { styles: r, classNames: t }), "data-position": "left", children: m }),
        h && /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemLabel", { styles: r, classNames: t }), children: h }),
        u && /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemSection", { styles: r, classNames: t }), "data-position": "right", children: u })
      ]
    }
  );
});
Me.classes = O;
Me.displayName = "@mantine/core/MenuItem";
const De = M((e, o) => {
  const { classNames: t, className: n, style: c, styles: r, vars: s, ...a } = b(
    "MenuLabel",
    null,
    e
  ), i = F();
  return /* @__PURE__ */ l.jsx(
    R,
    {
      ref: o,
      ...i.getStyles("label", { className: n, style: c, styles: r, classNames: t }),
      ...a
    }
  );
});
De.classes = O;
De.displayName = "@mantine/core/MenuLabel";
const Ie = M((e, o) => {
  const {
    classNames: t,
    className: n,
    style: c,
    styles: r,
    vars: s,
    onMouseEnter: a,
    onMouseLeave: i,
    onKeyDown: m,
    children: u,
    ...h
  } = b("MenuSubDropdown", null, e), g = z(null), f = F(), d = ae(), p = w(a, d?.open), y = w(i, d?.close);
  return /* @__PURE__ */ l.jsx(
    K.Dropdown,
    {
      ...h,
      onMouseEnter: p,
      onMouseLeave: y,
      role: "menu",
      "aria-orientation": "vertical",
      ref: se(o, g),
      ...f.getStyles("dropdown", {
        className: n,
        style: c,
        styles: r,
        classNames: t,
        withStaticClass: !1
      }),
      tabIndex: -1,
      "data-menu-dropdown": !0,
      children: u
    }
  );
});
Ie.classes = O;
Ie.displayName = "@mantine/core/MenuSubDropdown";
const Te = be((e, o) => {
  const {
    classNames: t,
    className: n,
    style: c,
    styles: r,
    vars: s,
    color: a,
    leftSection: i,
    rightSection: m,
    children: u,
    disabled: h,
    "data-disabled": g,
    closeMenuOnClick: f,
    ...d
  } = b("MenuSubItem", null, e), p = F(), y = ae(), v = ve(), { dir: x } = Fe(), N = z(null), C = d, D = a ? v.variantColorResolver({ color: a, theme: v, variant: "light" }) : void 0, P = a ? _e({ color: a, theme: v }) : null, k = w(C.onKeyDown, (I) => {
    I.key === "ArrowRight" && (y?.open(), y?.focusFirstItem()), I.key === "ArrowLeft" && y?.parentContext && (y.parentContext.close(), y.parentContext.focusParentItem());
  }), E = w(C.onClick, () => {
    !g && f && p.closeDropdownImmediately();
  }), L = w(C.onMouseEnter, y?.open), S = w(C.onMouseLeave, y?.close);
  return /* @__PURE__ */ l.jsxs(
    we,
    {
      onMouseDown: (I) => I.preventDefault(),
      ...d,
      unstyled: p.unstyled,
      tabIndex: p.menuItemTabIndex,
      ...p.getStyles("item", { className: n, style: c, styles: r, classNames: t }),
      ref: se(N, o),
      role: "menuitem",
      disabled: h,
      "data-menu-item": !0,
      "data-sub-menu-item": !0,
      "data-disabled": h || g || void 0,
      "data-mantine-stop-propagation": !0,
      onMouseEnter: L,
      onMouseLeave: S,
      onClick: E,
      onKeyDown: Oe({
        siblingSelector: "[data-menu-item]:not([data-disabled])",
        parentSelector: "[data-menu-dropdown]",
        activateOnFocus: !1,
        loop: p.loop,
        dir: x,
        orientation: "vertical",
        onKeyDown: k
      }),
      __vars: {
        "--menu-item-color": P?.isThemeColor && P?.shade === void 0 ? `var(--mantine-color-${P.color}-6)` : D?.color,
        "--menu-item-hover": D?.hover
      },
      children: [
        i && /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemSection", { styles: r, classNames: t }), "data-position": "left", children: i }),
        u && /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemLabel", { styles: r, classNames: t }), children: u }),
        /* @__PURE__ */ l.jsx("div", { ...p.getStyles("itemSection", { styles: r, classNames: t }), "data-position": "right", children: m || /* @__PURE__ */ l.jsx(Ct, { ...p.getStyles("chevron"), size: 14 }) })
      ]
    }
  );
});
Te.classes = O;
Te.displayName = "@mantine/core/MenuSubItem";
function Ke({ children: e, refProp: o }) {
  if (!ft(e))
    throw new Error(
      "Menu.Sub.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  return F(), /* @__PURE__ */ l.jsx(K.Target, { refProp: o, popupType: "menu", children: e });
}
Ke.displayName = "@mantine/core/MenuSubTarget";
const Ft = {
  offset: 0,
  position: "right-start",
  transitionProps: { duration: 0 },
  openDelay: 0,
  middlewares: {
    shift: {
      // Enable crossAxis shift to keep submenu dropdown within viewport bounds when positioned horizontally
      crossAxis: !0
    }
  }
};
function V(e) {
  const { children: o, closeDelay: t, openDelay: n, ...c } = b("MenuSub", Ft, e), r = yt(), [s, { open: a, close: i }] = vt(!1), m = ae(), { openDropdown: u, closeDropdown: h } = ze({
    open: a,
    close: i,
    closeDelay: t,
    openDelay: n
  }), g = () => window.setTimeout(() => {
    document.getElementById(`${r}-dropdown`)?.querySelectorAll("[data-menu-item]:not([data-disabled])")[0]?.focus();
  }, 16), f = () => window.setTimeout(() => {
    document.getElementById(`${r}-target`)?.focus();
  }, 16);
  return /* @__PURE__ */ l.jsx(
    $t,
    {
      value: {
        opened: s,
        close: h,
        open: u,
        focusFirstItem: g,
        focusParentItem: f,
        parentContext: m
      },
      children: /* @__PURE__ */ l.jsx(K, { opened: s, withinPortal: !1, withArrow: !1, id: r, ...c, children: o })
    }
  );
}
V.extend = (e) => e;
V.displayName = "@mantine/core/MenuSub";
V.Target = Ke;
V.Dropdown = Ie;
V.Item = Te;
const Ot = {
  refProp: "ref"
}, Ve = Ae((e, o) => {
  const { children: t, refProp: n, ...c } = b("MenuTarget", Ot, e), r = bt(t);
  if (!r)
    throw new Error(
      "Menu.Target component children should be an element or a component that accepts ref. Fragments, strings, numbers and other primitive values are not supported"
    );
  const s = F(), a = r.props, i = w(a.onClick, () => {
    s.trigger === "click" ? s.toggleDropdown() : s.trigger === "click-hover" && (s.setOpenedViaClick(!0), s.opened || s.openDropdown());
  }), m = w(
    a.onMouseEnter,
    () => (s.trigger === "hover" || s.trigger === "click-hover") && s.openDropdown()
  ), u = w(a.onMouseLeave, () => {
    (s.trigger === "hover" || s.trigger === "click-hover" && !s.openedViaClick) && s.closeDropdown();
  });
  return /* @__PURE__ */ l.jsx(K.Target, { refProp: n, popupType: "menu", ref: o, ...c, children: ct(r, {
    onClick: i,
    onMouseEnter: m,
    onMouseLeave: u,
    "data-expanded": s.opened ? !0 : void 0
  }) });
});
Ve.displayName = "@mantine/core/MenuTarget";
const zt = {
  trapFocus: !0,
  closeOnItemClick: !0,
  withInitialFocusPlaceholder: !0,
  clickOutsideEvents: ["mousedown", "touchstart", "keydown"],
  loop: !0,
  trigger: "click",
  openDelay: 0,
  closeDelay: 100,
  menuItemTabIndex: -1
};
function T(e) {
  const o = b("Menu", zt, e), {
    children: t,
    onOpen: n,
    onClose: c,
    opened: r,
    defaultOpened: s,
    trapFocus: a,
    onChange: i,
    closeOnItemClick: m,
    loop: u,
    closeOnEscape: h,
    trigger: g,
    openDelay: f,
    closeDelay: d,
    classNames: p,
    styles: y,
    unstyled: v,
    variant: x,
    vars: N,
    menuItemTabIndex: C,
    keepMounted: D,
    withInitialFocusPlaceholder: P,
    attributes: k,
    ...E
  } = o, L = Z({
    name: "Menu",
    classes: O,
    props: o,
    classNames: p,
    styles: y,
    unstyled: v,
    attributes: k
  }), [S, I] = $e({
    value: r,
    defaultValue: s,
    finalValue: !1,
    onChange: i
  }), [U, B] = Ee(!1), A = () => {
    I(!1), B(!1), S && c?.();
  }, q = () => {
    I(!0), !S && n?.();
  }, Y = () => {
    S ? A() : q();
  }, { openDropdown: de, closeDropdown: ue } = ze({ open: q, close: A, closeDelay: d, openDelay: f }), pe = (et) => jt("[data-menu-item]", "[data-menu-dropdown]", et), { resolvedClassNames: me, resolvedStyles: he } = wt({
    classNames: p,
    styles: y,
    props: o
  });
  return /* @__PURE__ */ l.jsx(
    At,
    {
      value: {
        getStyles: L,
        opened: S,
        toggleDropdown: Y,
        getItemIndex: pe,
        openedViaClick: U,
        setOpenedViaClick: B,
        closeOnItemClick: m,
        closeDropdown: g === "click" ? A : ue,
        openDropdown: g === "click" ? q : de,
        closeDropdownImmediately: A,
        loop: u,
        trigger: g,
        unstyled: v,
        menuItemTabIndex: C,
        withInitialFocusPlaceholder: P
      },
      children: /* @__PURE__ */ l.jsx(
        K,
        {
          returnFocus: !0,
          ...E,
          opened: S,
          onChange: Y,
          defaultOpened: s,
          trapFocus: D ? !1 : a,
          closeOnEscape: h,
          __staticSelector: "Menu",
          classNames: me,
          styles: he,
          unstyled: v,
          variant: x,
          keepMounted: D,
          children: t
        }
      )
    }
  );
}
T.extend = (e) => e;
T.withProps = tt(T);
T.classes = O;
T.displayName = "@mantine/core/Menu";
T.Item = Me;
T.Label = De;
T.Dropdown = Se;
T.Target = Ve;
T.Divider = Pe;
T.Sub = V;
var G = { root: "m_4addd315", control: "m_326d024a", dots: "m_4ad7767d" };
const [Ht, re] = Ce(
  "Pagination.Root component was not found in tree"
), Bt = {
  withPadding: !0
}, J = M((e, o) => {
  const t = b("PaginationControl", Bt, e), {
    classNames: n,
    className: c,
    style: r,
    styles: s,
    vars: a,
    active: i,
    disabled: m,
    withPadding: u,
    mod: h,
    ...g
  } = t, f = re(), d = m || f.disabled;
  return /* @__PURE__ */ l.jsx(
    we,
    {
      ref: o,
      disabled: d,
      mod: [{ active: i, disabled: d, "with-padding": u }, h],
      ...f.getStyles("control", { className: c, style: r, classNames: n, styles: s, active: !d }),
      ...g
    }
  );
});
J.classes = G;
J.displayName = "@mantine/core/PaginationControl";
function Q({ style: e, children: o, path: t, ...n }) {
  return /* @__PURE__ */ l.jsx(
    "svg",
    {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      style: {
        width: "calc(var(--pagination-control-size) / 1.8)",
        height: "calc(var(--pagination-control-size) / 1.8)",
        ...e
      },
      ...n,
      children: /* @__PURE__ */ l.jsx("path", { d: t, fill: "currentColor" })
    }
  );
}
const Kt = (e) => /* @__PURE__ */ l.jsx(
  Q,
  {
    ...e,
    path: "M8.781 8l-3.3-3.3.943-.943L10.667 8l-4.243 4.243-.943-.943 3.3-3.3z"
  }
), Vt = (e) => /* @__PURE__ */ l.jsx(
  Q,
  {
    ...e,
    path: "M7.219 8l3.3 3.3-.943.943L5.333 8l4.243-4.243.943.943-3.3 3.3z"
  }
), Ut = (e) => /* @__PURE__ */ l.jsx(
  Q,
  {
    ...e,
    path: "M6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.14645 7.14645C1.95118 7.34171 1.95118 7.65829 2.14645 7.85355L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355ZM12.8536 3.85355C13.0488 3.65829 13.0488 3.34171 12.8536 3.14645C12.6583 2.95118 12.3417 2.95118 12.1464 3.14645L8.14645 7.14645C7.95118 7.34171 7.95118 7.65829 8.14645 7.85355L12.1464 11.8536C12.3417 12.0488 12.6583 12.0488 12.8536 11.8536C13.0488 11.6583 13.0488 11.3417 12.8536 11.1464L9.20711 7.5L12.8536 3.85355Z"
  }
), qt = (e) => /* @__PURE__ */ l.jsx(
  Q,
  {
    ...e,
    path: "M2.14645 11.1464C1.95118 11.3417 1.95118 11.6583 2.14645 11.8536C2.34171 12.0488 2.65829 12.0488 2.85355 11.8536L6.85355 7.85355C7.04882 7.65829 7.04882 7.34171 6.85355 7.14645L2.85355 3.14645C2.65829 2.95118 2.34171 2.95118 2.14645 3.14645C1.95118 3.34171 1.95118 3.65829 2.14645 3.85355L5.79289 7.5L2.14645 11.1464ZM8.14645 11.1464C7.95118 11.3417 7.95118 11.6583 8.14645 11.8536C8.34171 12.0488 8.65829 12.0488 8.85355 11.8536L12.8536 7.85355C13.0488 7.65829 13.0488 7.34171 12.8536 7.14645L8.85355 3.14645C8.65829 2.95118 8.34171 2.95118 8.14645 3.14645C7.95118 3.34171 7.95118 3.65829 8.14645 3.85355L11.7929 7.5L8.14645 11.1464Z"
  }
), Wt = (e) => /* @__PURE__ */ l.jsx(
  Q,
  {
    ...e,
    path: "M2 8c0-.733.6-1.333 1.333-1.333.734 0 1.334.6 1.334 1.333s-.6 1.333-1.334 1.333C2.6 9.333 2 8.733 2 8zm9.333 0c0-.733.6-1.333 1.334-1.333C13.4 6.667 14 7.267 14 8s-.6 1.333-1.333 1.333c-.734 0-1.334-.6-1.334-1.333zM6.667 8c0-.733.6-1.333 1.333-1.333s1.333.6 1.333 1.333S8.733 9.333 8 9.333 6.667 8.733 6.667 8z"
  }
), Zt = {
  icon: Wt
}, ie = M((e, o) => {
  const t = b("PaginationDots", Zt, e), { classNames: n, className: c, style: r, styles: s, vars: a, icon: i, ...m } = t, u = re();
  return /* @__PURE__ */ l.jsx(R, { ref: o, ...u.getStyles("dots", { className: c, style: r, styles: s, classNames: n }), ...m, children: /* @__PURE__ */ l.jsx(
    i,
    {
      style: {
        width: "calc(var(--pagination-control-size) / 1.8)",
        height: "calc(var(--pagination-control-size) / 1.8)"
      }
    }
  ) });
});
ie.classes = G;
ie.displayName = "@mantine/core/PaginationDots";
function le({ icon: e, name: o, action: t, type: n }) {
  const c = { icon: e }, r = Ae((s, a) => {
    const { icon: i, ...m } = b(o, c, s), u = re(), h = n === "next" ? u.active === u.total : u.active === 1;
    return /* @__PURE__ */ l.jsx(
      J,
      {
        disabled: u.disabled || h,
        ref: a,
        onClick: u[t],
        withPadding: !1,
        ...m,
        children: /* @__PURE__ */ l.jsx(
          i,
          {
            className: "mantine-rotate-rtl",
            style: {
              width: "calc(var(--pagination-control-size) / 1.8)",
              height: "calc(var(--pagination-control-size) / 1.8)"
            }
          }
        )
      }
    );
  });
  return r.displayName = `@mantine/core/${o}`, ot(r);
}
const Ue = le({
  icon: Kt,
  name: "PaginationNext",
  action: "onNext",
  type: "next"
}), qe = le({
  icon: Vt,
  name: "PaginationPrevious",
  action: "onPrevious",
  type: "previous"
}), We = le({
  icon: Ut,
  name: "PaginationFirst",
  action: "onFirst",
  type: "previous"
}), Ze = le({
  icon: qt,
  name: "PaginationLast",
  action: "onLast",
  type: "next"
});
function je({ dotsIcon: e }) {
  const o = re(), t = o.range.map((n, c) => n === "dots" ? /* @__PURE__ */ l.jsx(ie, { icon: e }, c) : /* @__PURE__ */ l.jsx(
    J,
    {
      active: n === o.active,
      "aria-current": n === o.active ? "page" : void 0,
      onClick: () => o.onChange(n),
      disabled: o.disabled,
      ...o.getItemProps?.(n),
      children: o.getItemProps?.(n)?.children ?? n
    },
    c
  ));
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: t });
}
je.displayName = "@mantine/core/PaginationItems";
const Gt = {
  siblings: 1,
  boundaries: 1
}, Jt = xe(
  (e, { size: o, radius: t, color: n, autoContrast: c }) => ({
    root: {
      "--pagination-control-radius": t === void 0 ? void 0 : at(t),
      "--pagination-control-size": st(o, "pagination-control-size"),
      "--pagination-control-fz": nt(o),
      "--pagination-active-bg": n ? te(n, e) : void 0,
      "--pagination-active-color": Pt(c, e) ? St({ color: n, theme: e, autoContrast: c }) : void 0
    }
  })
), ce = M((e, o) => {
  const t = b("PaginationRoot", Gt, e), {
    classNames: n,
    className: c,
    style: r,
    styles: s,
    unstyled: a,
    vars: i,
    total: m,
    value: u,
    defaultValue: h,
    onChange: g,
    disabled: f,
    siblings: d,
    boundaries: p,
    color: y,
    radius: v,
    onNextPage: x,
    onPreviousPage: N,
    onFirstPage: C,
    onLastPage: D,
    getItemProps: P,
    autoContrast: k,
    attributes: E,
    ...L
  } = t, S = Z({
    name: "Pagination",
    classes: G,
    props: t,
    className: c,
    style: r,
    classNames: n,
    styles: s,
    unstyled: a,
    attributes: E,
    vars: i,
    varsResolver: Jt
  }), { range: I, setPage: U, next: B, previous: A, active: q, first: Y, last: de } = Nt({
    page: u,
    initialPage: h,
    onChange: g,
    total: m,
    siblings: d,
    boundaries: p
  }), ue = w(x, B), pe = w(N, A), me = w(C, Y), he = w(D, de);
  return /* @__PURE__ */ l.jsx(
    Ht,
    {
      value: {
        total: m,
        range: I,
        active: q,
        disabled: f,
        getItemProps: P,
        onChange: U,
        onNext: ue,
        onPrevious: pe,
        onFirst: me,
        onLast: he,
        getStyles: S
      },
      children: /* @__PURE__ */ l.jsx(R, { ref: o, ...S("root"), ...L })
    }
  );
});
ce.classes = G;
ce.displayName = "@mantine/core/PaginationRoot";
const Qt = {
  withControls: !0,
  withPages: !0,
  siblings: 1,
  boundaries: 1,
  gap: 8
}, _ = M((e, o) => {
  const t = b("Pagination", Qt, e), {
    withEdges: n,
    withControls: c,
    getControlProps: r,
    nextIcon: s,
    previousIcon: a,
    lastIcon: i,
    firstIcon: m,
    dotsIcon: u,
    total: h,
    gap: g,
    hideWithOnePage: f,
    withPages: d,
    ...p
  } = t;
  return h <= 0 || f && h === 1 ? null : /* @__PURE__ */ l.jsx(ce, { ref: o, total: h, ...p, children: /* @__PURE__ */ l.jsxs(xt, { gap: g, children: [
    n && /* @__PURE__ */ l.jsx(We, { icon: m, ...r?.("first") }),
    c && /* @__PURE__ */ l.jsx(qe, { icon: a, ...r?.("previous") }),
    d && /* @__PURE__ */ l.jsx(je, { dotsIcon: u }),
    c && /* @__PURE__ */ l.jsx(Ue, { icon: s, ...r?.("next") }),
    n && /* @__PURE__ */ l.jsx(Ze, { icon: i, ...r?.("last") })
  ] }) });
});
_.classes = G;
_.displayName = "@mantine/core/Pagination";
_.Root = ce;
_.Control = J;
_.Dots = ie;
_.First = We;
_.Last = Ze;
_.Next = Ue;
_.Previous = qe;
_.Items = je;
const [Xt, Yt] = Ce(
  "Table component was not found in the tree"
);
var X = { table: "m_b23fa0ef", th: "m_4e7aa4f3", tr: "m_4e7aa4fd", td: "m_4e7aa4ef", tbody: "m_b2404537", thead: "m_b242d975", caption: "m_9e5a3ac7", scrollContainer: "m_a100c15", scrollContainerInner: "m_62259741" };
function eo(e, o) {
  if (!o)
    return;
  const t = {};
  return o.columnBorder && e.withColumnBorders && (t["data-with-column-border"] = !0), o.rowBorder && e.withRowBorders && (t["data-with-row-border"] = !0), o.striped && e.striped && (t["data-striped"] = e.striped), o.highlightOnHover && e.highlightOnHover && (t["data-hover"] = !0), o.captionSide && e.captionSide && (t["data-side"] = e.captionSide), o.stickyHeader && e.stickyHeader && (t["data-sticky"] = !0), t;
}
function H(e, o) {
  const t = `Table${e.charAt(0).toUpperCase()}${e.slice(1)}`, n = M((c, r) => {
    const s = b(t, {}, c), { classNames: a, className: i, style: m, styles: u, ...h } = s, g = Yt();
    return /* @__PURE__ */ l.jsx(
      R,
      {
        component: e,
        ref: r,
        ...eo(g, o),
        ...g.getStyles(e, { className: i, classNames: a, style: m, styles: u, props: s }),
        ...h
      }
    );
  });
  return n.displayName = `@mantine/core/${t}`, n.classes = X, n;
}
const ye = H("th", { columnBorder: !0 }), Ge = H("td", { columnBorder: !0 }), oe = H("tr", {
  rowBorder: !0,
  striped: !0,
  highlightOnHover: !0
}), Je = H("thead", { stickyHeader: !0 }), Qe = H("tbody"), Xe = H("tfoot"), Ye = H("caption", { captionSide: !0 });
function Ne({ data: e }) {
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    e.caption && /* @__PURE__ */ l.jsx(Ye, { children: e.caption }),
    e.head && /* @__PURE__ */ l.jsx(Je, { children: /* @__PURE__ */ l.jsx(oe, { children: e.head.map((o, t) => /* @__PURE__ */ l.jsx(ye, { children: o }, t)) }) }),
    e.body && /* @__PURE__ */ l.jsx(Qe, { children: e.body.map((o, t) => /* @__PURE__ */ l.jsx(oe, { children: o.map((n, c) => /* @__PURE__ */ l.jsx(Ge, { children: n }, c)) }, t)) }),
    e.foot && /* @__PURE__ */ l.jsx(Xe, { children: /* @__PURE__ */ l.jsx(oe, { children: e.foot.map((o, t) => /* @__PURE__ */ l.jsx(ye, { children: o }, t)) }) })
  ] });
}
Ne.displayName = "@mantine/core/TableDataRenderer";
const to = {
  type: "scrollarea"
}, oo = xe(
  (e, { minWidth: o, maxHeight: t, type: n }) => ({
    scrollContainer: {
      "--table-min-width": fe(o),
      "--table-max-height": fe(t),
      "--table-overflow": n === "native" ? "auto" : void 0
    }
  })
), ke = M((e, o) => {
  const t = b("TableScrollContainer", to, e), {
    classNames: n,
    className: c,
    style: r,
    styles: s,
    unstyled: a,
    vars: i,
    children: m,
    minWidth: u,
    maxHeight: h,
    type: g,
    scrollAreaProps: f,
    attributes: d,
    ...p
  } = t, y = Z({
    name: "TableScrollContainer",
    classes: X,
    props: t,
    className: c,
    style: r,
    classNames: n,
    styles: s,
    unstyled: a,
    attributes: d,
    vars: i,
    varsResolver: oo,
    rootSelector: "scrollContainer"
  });
  return /* @__PURE__ */ l.jsx(
    R,
    {
      component: g === "scrollarea" ? Mt : "div",
      ...g === "scrollarea" ? h ? { offsetScrollbars: "xy", ...f } : { offsetScrollbars: "x", ...f } : {},
      ref: o,
      ...y("scrollContainer"),
      ...p,
      children: /* @__PURE__ */ l.jsx("div", { ...y("scrollContainerInner"), children: m })
    }
  );
});
ke.classes = X;
ke.displayName = "@mantine/core/TableScrollContainer";
const no = {
  withRowBorders: !0,
  verticalSpacing: 7
}, so = xe(
  (e, {
    layout: o,
    captionSide: t,
    horizontalSpacing: n,
    verticalSpacing: c,
    borderColor: r,
    stripedColor: s,
    highlightOnHoverColor: a,
    striped: i,
    highlightOnHover: m,
    stickyHeaderOffset: u,
    stickyHeader: h
  }) => ({
    table: {
      "--table-layout": o,
      "--table-caption-side": t,
      "--table-horizontal-spacing": Le(n),
      "--table-vertical-spacing": Le(c),
      "--table-border-color": r ? te(r, e) : void 0,
      "--table-striped-color": i && s ? te(s, e) : void 0,
      "--table-highlight-on-hover-color": m && a ? te(a, e) : void 0,
      "--table-sticky-header-offset": h ? fe(u) : void 0
    }
  })
), j = M((e, o) => {
  const t = b("Table", no, e), {
    classNames: n,
    className: c,
    style: r,
    styles: s,
    unstyled: a,
    vars: i,
    horizontalSpacing: m,
    verticalSpacing: u,
    captionSide: h,
    stripedColor: g,
    highlightOnHoverColor: f,
    striped: d,
    highlightOnHover: p,
    withColumnBorders: y,
    withRowBorders: v,
    withTableBorder: x,
    borderColor: N,
    layout: C,
    variant: D,
    data: P,
    children: k,
    stickyHeader: E,
    stickyHeaderOffset: L,
    mod: S,
    tabularNums: I,
    attributes: U,
    ...B
  } = t, A = Z({
    name: "Table",
    props: t,
    className: c,
    style: r,
    classes: X,
    classNames: n,
    styles: s,
    unstyled: a,
    attributes: U,
    rootSelector: "table",
    vars: i,
    varsResolver: so
  });
  return /* @__PURE__ */ l.jsx(
    Xt,
    {
      value: {
        getStyles: A,
        stickyHeader: E,
        striped: d === !0 ? "odd" : d || void 0,
        highlightOnHover: p,
        withColumnBorders: y,
        withRowBorders: v,
        captionSide: h || "bottom"
      },
      children: /* @__PURE__ */ l.jsx(
        R,
        {
          component: "table",
          variant: D,
          ref: o,
          mod: [{ "data-with-table-border": x, "data-tabular-nums": I }, S],
          ...A("table"),
          ...B,
          children: k || !!P && /* @__PURE__ */ l.jsx(Ne, { data: P })
        }
      )
    }
  );
});
j.classes = X;
j.displayName = "@mantine/core/Table";
j.Td = Ge;
j.Th = ye;
j.Tr = oe;
j.Thead = Je;
j.Tbody = Qe;
j.Tfoot = Xe;
j.Caption = Ye;
j.ScrollContainer = ke;
j.DataRenderer = Ne;
export {
  Et as C,
  T as M,
  _ as P,
  j as T,
  Be as a,
  Je as b,
  Oe as c,
  oe as d,
  Xe as e,
  ye as f,
  Ge as g,
  Ve as h,
  Se as i,
  Me as j
};
